import React, { useEffect } from "react";
import { GIF_UPLOAD, IMAGE_UPLOAD } from "../../Constants/types";
import "./index.css";

const GifCard = ({ item }) => {
  const setBackgroundSize = (url) => {
    const imageContainer = document.getElementById(item.id);
    const img = new Image();

    img.onload = function () {
      const imageWidth = this.width;
      const imageHeight = this.height;
      const containerWidth = imageContainer.offsetWidth;
      const containerHeight = imageContainer.offsetHeight;

      if (imageWidth <= containerWidth && imageHeight <= containerHeight) {
        imageContainer.style.backgroundSize = "unset";
      } else if (
        imageWidth <= containerWidth &&
        imageHeight <= containerHeight
      ) {
        imageContainer.style.backgroundSize = "contain";
      } else imageContainer.style.backgroundSize = "cover";
    };
    img.src = url;
  };

  useEffect(() => {
    item && setBackgroundSize(item.media_url);
  }, []);

  return (
    <div className="hotVideo-card">
      <div
        className="background"
        id={item.id}
        style={{
          backgroundImage:
            item.media_type === GIF_UPLOAD || item.media_type === IMAGE_UPLOAD
              ? `url(${item.media_url})`
              : "unset",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          borderRadius: 12,
        }}
      />
    </div>
  );
};
export default GifCard;



// WEBPACK FOOTER //
// ./src/screens/HotTopic/GifCard.js